import React, { useState, useRef, useEffect } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useCart } from '../context/CartContext';
import './Navbar.css';

export default function Navbar() {
  const { admin, logout } = useAuth();
  const { totalItems } = useCart();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [adminDropdownOpen, setAdminDropdownOpen] = useState(false);
  const adminWrapRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(e) {
      if (!adminDropdownOpen) return;
      if (adminWrapRef.current && !adminWrapRef.current.contains(e.target)) {
        setAdminDropdownOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [adminDropdownOpen]);

  const handleLogout = async () => {
    await logout();
    setMenuOpen(false);
    setAdminDropdownOpen(false);
    navigate('/');
  };

  const close = () => setMenuOpen(false);

  const closeAll = () => {
    close();
    setAdminDropdownOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="navbar-brand">
        <Link to="/" onClick={closeAll} aria-label="Vikky Gold Palace - Home" className="brand-link">
          <span className="navbar-logo-wrap">
            <img src="/logo.jpeg" alt="Vikky Gold Palace" className="navbar-logo" />
          </span>
          <span className="navbar-title">Vikky Gold Palace</span>
        </Link>
      </div>

      <button className="navbar-toggle" onClick={() => setMenuOpen(!menuOpen)} aria-label="Toggle navigation">
        ☰
      </button>

      <div className={`navbar-links ${menuOpen ? 'open' : ''}`}>
        <NavLink to="/" end onClick={closeAll} className={({ isActive }) => (isActive ? 'nav-active' : undefined)}>Home</NavLink>
        <NavLink to="/section/gold" onClick={closeAll} className={({ isActive }) => (isActive ? 'nav-active' : undefined)}>Gold</NavLink>
        <NavLink to="/section/silver" onClick={closeAll} className={({ isActive }) => (isActive ? 'nav-active' : undefined)}>Silver</NavLink>
        <NavLink to="/section/gold-plated" onClick={closeAll} className={({ isActive }) => (isActive ? 'nav-active' : undefined)}>Gold Plated</NavLink>
        <NavLink to="/section/fancy" onClick={closeAll} className={({ isActive }) => (isActive ? 'nav-active' : undefined)}>Fancy</NavLink>
        <NavLink to="/contact" onClick={closeAll} className={({ isActive }) => (isActive ? 'nav-active' : undefined)}>Contact</NavLink>
        <Link to="/cart" onClick={closeAll} className="navbar-cart">
          🛒 Cart{totalItems > 0 && <span className="cart-badge">{totalItems}</span>}
        </Link>
        {admin && (
          <>
            <div className="navbar-admin-wrap" ref={adminWrapRef}>
              <button
                type="button"
                className="navbar-admin-trigger"
                aria-expanded={adminDropdownOpen}
                aria-haspopup="true"
                onClick={() => setAdminDropdownOpen((o) => !o)}
              >
                Admin actions
                <span className="navbar-admin-chevron" aria-hidden>{adminDropdownOpen ? '▴' : '▾'}</span>
              </button>
              {adminDropdownOpen && (
                <div className="navbar-admin-dropdown" role="menu">
                  <Link to="/admin" role="menuitem" onClick={closeAll}>Catalog &amp; jewels</Link>
                  <Link to="/admin/enquiries" role="menuitem" onClick={closeAll}>Enquiries</Link>
                  <Link to="/admin/billing" role="menuitem" onClick={closeAll}>Billing</Link>
                </div>
              )}
            </div>
            <button className="navbar-logout" onClick={handleLogout}>Logout</button>
          </>
        )}
      </div>
    </nav>
  );
}
